import Lookup from './lookup.js';

export default class AdmissionChannel extends Lookup
{
    
}